import React from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col } from 'react-bootstrap';
import { HEADER } from 'utils/sectionTypes';
import { BUILDER } from 'shared/abilities';
import { section } from '../decorators';

const propTypes = {
  children: PropTypes.node.isRequired,
};

const defaultProps = {};

const HeaderEmbed = ({ children }) => {
  const [embedWdgt, embedWidget] = React.Children.toArray(children);

  return (
    <div>
      <Container>
        <Row>
          <Col xs={8} className="hidden-xs">
            <div>
              {embedWdgt}
            </div>
          </Col>
          <Col xs={10} sm={4}>
            {embedWidget}
          </Col>
        </Row>
      </Container>
    </div>
  );
};

HeaderEmbed.propTypes = propTypes;
HeaderEmbed.defaultProps = defaultProps;

const component = section(
  { name: 'Header: Embed', region: HEADER, category: 'Header / Navigation' },
  {
    subsections: [
      { accepts: ['EmbedContent'] },
      { accepts: ['EmbedContent'] },
    ],
    defaults: [
      ['EmbedContent'],
      ['EmbedContent'],
    ],
  },
)(HeaderEmbed);

component.authorization = { action: 'manage', subject: BUILDER };

export default component;
